
/*
 * mkb-framework
 * ============================================================================
 * Require Config
 * ============================================================================
 * author: mikabo
 * http://www.mikabo.com
 * ============================================================================
 * Copyright (c) 2015, mikabo
 * All rights reserved.
 * ============================================================================
 */
// This is the runtime configuration file.  It complements the Gruntfile.js by
// supplementing shared properties.
require.config({

	paths: {
		// Make vendor easier to access.
		'vendor'											: '../vendor',

		// Almond is used to lighten the output filesize.
		'almond'											: '../vendor/bower/almond/almond',


		// Opt for Lo-Dash Underscore compatibility build over Underscore.
		'underscore'										: '../vendor/bower/lodash/dist/lodash.underscore',

		// Map `lodash` to a valid location for the template loader plugin.
		//'lodash'											: '../vendor/bower/lodash/dist/lodash',

		// Use the Lo-Dash template loader.
		//'ldsh'											: '../vendor/bower/lodash-template-loader/loader',

		// Map remaining vendor dependencies.
		'jquery'											: '../vendor/bower/jquery/jquery',

		//'backbone'										: '../vendor/bower/backbone/backbone',
		//'layoutmanager'									: '../vendor/bower/layoutmanager/backbone.layoutmanager',
		//------------------------------------------------------------------
		//Above PLUGINS for Backbone


		// Default PLUGINS
		//------------------------------------------------------------------

		//'backbone.validation'								: '../vendor/bower/backbone-validation/src/backbone-validation-mkb',
		//'backbone.stickit'								: '../vendor/bower/backbone.stickit/backbone.stickit',
		'jquery.backstretch'								: '../vendor/bower/jquery-backstretch/jquery.backstretch',
		'mCustomScrollbar'									: '../vendor/bower/malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar',


		// Default PLUGINS
		//------------------------------------------------------------------
		'domready'											: '../vendor/bower/domready/ready',
		'device'											: '../vendor/bower/devicejs/lib/device',
		//'fastclick'										: '../vendor/bower/fastclick/lib/fastclick',

		// Custom PLUGINS
		//------------------------------------------------------------------
		'mkb.pegel'											: '../vendor/pegel/mkb.pegel',
		'xdr'												: '../vendor/pegel/xdr',
		//'select2'											: '../vendor/bower/select2/select2',
		//'bootstrap.datepicker'							: '../vendor/bootstrap-datepicker/js/bootstrap-datepicker',

	},

	// Only For Backbone
	//------------------------------------------------------------------
	shim: {
		// This is required to ensure Backbone works as expected within the AMD
		// environment.
		'backbone': {
			// These are the two hard dependencies that will be loaded first.
			deps: ['jquery', 'underscore'],

			// This maps the global `Backbone` object to `require('backbone')`.
			exports: 'Backbone'
		},


	// 	// PLUGINS depend on jQuery
	// 	//------------------------------------------------------------------
		//'jquery-plugin'								: ['jquery'],
		//'select2'										: ['jquery'],
		'jquery.backstretch'							: ['jquery'],
		'mCustomScrollbar'								: ['jquery'],
		'mkb.pegel'										: ['jquery','xdr']


		// PLUGINS depend on Backbone
		//------------------------------------------------------------------
		//'backbone.plugin'								: ['backbone'],
		//'backbone.validation'							: ['backbone'],
		//'backbone.stickit'								: ['backbone']


		// Create Amd
		//------------------------------------------------------------------
		//'plugin'										: []

	}
});

define("config", function(){});
